// test690
(690 && 0);
